export default function     FileUpload ({id, label, onChange, classes}) {
    return (
    <div className="relative flex flex-col">
        <label htmlFor={id} className="w-full mb-2">{label}</label>
        <input onChange={(e) => onChange(e.target.files[0])} className={`file:mr-4 file:py-2 file:px-4 file:border-0 file:text-sm text-sm file:font-semibold file:bg-servo-400 file:text-white block w-full text-gray-900 rounded-lg border border-gray-300 cursor-pointer focus:outline-none focus:border-transparent ${classes}`} id={id} type="file" />
    </div>
    );
}